import React from "react";
import ct from "class-types.macro";
interface Props {
  bannerMessage: string;
}
const Header = ({
  bannerMessage
}: Props) => {
  return <div className={ct("bg-green-500", "flex", "flex-col", "justify-center", "p-2", "lt:p-4", "lt:text-center")} data-sentry-component="Header" data-sentry-source-file="index.tsx">
      <h3 className={ct("text-shadow-none", "font-bold", "text-base", "leading-tight", "mb-0", "text-white", "w-3/4", "lt:text-xl", "lt:w-40", "lz:text-2xl", "lz:w-49")}>
        {bannerMessage}
      </h3>
    </div>;
};
export default Header;